// extracted by mini-css-extract-plugin
module.exports = {"desktopH":"styles_desktopH__2vJ8n","movileH":"styles_movileH__2WwZc"};